import { httpRequest } from "@services/http";
import { SegmentPopulation } from "@models/population.model";

export class CommandSetSegmentControlGroup {
  async run(populationSegmentId: number, enabled: boolean, pct: number): Promise<SegmentPopulation> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/engagements/populations/${populationSegmentId}/control/`;
    return httpRequest<SegmentPopulation>(url, { method: "POST", body: { enabled, pct } });
  }
}
